module.exports = __webpack_public_path__ + "static/media/Slide21.4806ce19.JPG";